import React from "react";
import PropTypes from "prop-types";

// components
import CircleSVG from "./CircleSVG";

// styles
import "./circle.scss";

const Circle = (props) => {
  const { diameter, left, top, float, rotate, max, min, mobile } = props;

  return (
    <div
      className={`blue-circle-container ${float} ${mobile && "mobile"}`}
      style={{
        position: "absolute",
        top,
        left,
      }}
    >
      <div
        className={`blue-circle  ${rotate} ${
          mobile && min > 390 ? "no-rotate" : ""
        }`}
        style={{
          width: `${diameter}vw`,
          height: `${diameter}vw`,
          borderRadius: "50%",
          maxWidth: `${max}px`,
          minWidth: `${min}px`,
        }}
      >
        <CircleSVG />
      </div>
    </div>
  );
};

export default Circle;

Circle.defaultProps = {
  diameter: 50,
  left: "",
  top: "",
  float: "",
  rotate: "0",
  max: 200,
  min: 100,
};

Circle.propTypes = {
  diameter: PropTypes.number,
  left: PropTypes.string,
  top: PropTypes.string,
  float: PropTypes.string,
  rotate: PropTypes.string,
  max: PropTypes.number,
};
